import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PhysicianConsultationTab from "../Components/PhysicianConsultationTab";
import { userpatient } from "../Constant/Index";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";

const PhysicianMyConsultations = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 class="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											My Consultations
										</h5>
										<PhysicianConsultationTab />
									</div>
								</div>
								<div className="row">
									<div className="col-lg-6">
										<div className="doctor-detail-des main-profile-content radius-20 p-4">
											<div className="d-flex align-items-start justify-content-between mb-2">
												<div className="d-flex align-items-center gap-3 ">
													<img src={userpatient} className="img-fluid" alt="" />
													<div>
														<h4 className="main-heading-font dark-color mb-0">
															Jon Doe
														</h4>
														<h5 className="mb-0 extra-color-9">Patient</h5>
													</div>
												</div>
												<div className="dot d-flex align-items-center gap-1">
													<i class="fa-solid fa-circle"></i>
													<i class="fa-solid fa-circle"></i>
													<i class="fa-solid fa-circle"></i>
												</div>
											</div>
											<div className="mt-4 ">
												<Link
													className="detail-physician-btn d-flex w-100"
													to="/physician-consultation-detail"
												>
													<span>
														<i class="fa-regular fa-calendar"></i>{" "}
													</span>
													Sun - May 10, 1:00pm - 2:00pm
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianMyConsultations;
